import './scss/index.scss';
import { dcFactory } from 'dc';
import ProductComponent from './js/product.component.js';

dcFactory.register(ProductComponent);
